if(document.querySelector('.section-tabs--switch')) {
  const tab_items = document.querySelectorAll('.section-tabs-item');
  function hideTabItems (tab_items) {
    tab_items.forEach(tab_item => {
      tab_item.style.display = 'none';
    });
  }
  function showTabItems (active_tab_items) {
    active_tab_items.forEach(active_tab => {
      active_tab.style.display = 'block';
    });
  }
  hideTabItems(tab_items);
  var tab_count = 0;
  const tabs_switch = document.querySelectorAll('.section-tabs--switch');
  tabs_switch.forEach(tabs_section => {
    tabs = tabs_section.querySelectorAll('.section-tabs--tab');
    tabs.forEach(tab => {
      if(tab_count++ == 0) {
        active_tab_items = document.querySelectorAll('.'+tab.dataset.tab);
        showTabItems (active_tab_items);
      }
      tab.onclick = function (e) {
        e.preventDefault();
        tabs.forEach(tab_link => {
          tab_link.parentElement.classList.remove('active');
        });
        this.parentElement.classList.add('active');
        hideTabItems(tab_items);
        current_active_tab = document.querySelectorAll('.'+this.dataset.tab);
        showTabItems (current_active_tab);
        console.log("asdasdasd",this.dataset.tab);
      }
    });
  });
}